// Matches the jobsearch api timeout. Speak to the #jobsearch
// team when changing this value.
export const SEARCH_API_TIMEOUT = 3000;
